(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminTaskEditSettingsController', AdminTaskEditSettingsController);

    function AdminTaskEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'task_force_service_routine'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                'task_force_service_routine': { type: 'checkbox' }
            })
        });
        angular.extend(vm, base);
    }
})();
